import styled from 'styled-components';

export const GlobalWrapperStyles = styled.div`
    &&& {
        position: fixed;
        bottom: 40px;
        left: 101px;
        box-shadow: 0px 0px 6px 4px #c4c4c4;
        border-radius: 3px;
        z-index: 100;
    }
`;
